import { OnlineItemBaseController } from "./online-item-base.controller";

export class ClosingOnlineItemController extends OnlineItemBaseController {
    public static $inject: string[] = [
        "$element",
        "$scope",
        "categoryService",
        "mediaGalleryService",
        "onlineItemEdit",
        "utilsService"
    ];

    protected readOnly: boolean = true;

    constructor(
        protected $element,
        protected $scope: ng.IScope,
        protected categoryService,
        protected mediaGalleryService,
        protected onlineItemEdit,
        protected utilsService
    ) {
        super($element, $scope, categoryService, mediaGalleryService, onlineItemEdit);
    }

    public $onInit() {
        this._watchInView();
    }
}
